import { TraitGroupProps } from '@design-system/trait-group';

import { imageMapper } from '~/mappers/image';

import { TraitGroup } from './models';

export const traitGroupMapper = ({
  direction,
  size,
  textAlign,
  items,
  withBackground,
}: TraitGroup): TraitGroupProps =>
  ({
    direction,
    size,
    textAlign,
    withBackground,
    items: items.map(({ image, description }) => ({
      description,
      image: image?.image && imageMapper(image),
    })),
  } as TraitGroupProps);
